<template>
    <div id="MeetingReservation">
        <div class="view-header">
            <div>
                <el-radio-group v-model="selectType" @input="handleSelectTypeChanged">
                    <el-radio-button label="月"></el-radio-button>
                    <el-radio-button label="周"></el-radio-button>
                    <el-radio-button label="日"></el-radio-button>
                </el-radio-group>
            </div>
            <div v-if="selectType === '月'" v-text-lbl="'hygl.hyyt.meetingMap'">会议室导览图</div>
            <div style="display: flex;align-items: center;">
                <div v-if="selectType === '周'" style="margin-right: 20px;font-size: 16px;">
                    <div>
                        <span style="margin: 0 8px;">
                            <i class="el-icon-arrow-left" @click="handleWeekChanged('prev')"></i>
                            <span style="margin:0 8px;">{{ weekTimeArr[0] }} 至 {{ weekTimeArr[1] }}</span>
                            <i class="el-icon-arrow-right" @click="handleWeekChanged('next')"></i>
                        </span>
                        <el-link type="primary" :underline="false" @click="handleWeekChanged('today')">本周</el-link>
                    </div>
                </div>
                <div v-if="selectType === '日'" style="margin-right: 20px;font-size: 16px;">
                    <div>
                        <span style="margin: 0 8px;">
                            <i class="el-icon-arrow-left" @click="handleDayChanged('prev')"></i>
                            <span style="margin:0 8px;">{{ dayTime }}</span>
                            <i class="el-icon-arrow-right" @click="handleDayChanged('next')"></i>
                        </span>
                        <el-link type="primary" :underline="false" @click="handleDayChanged('today')">本日</el-link>
                    </div>
                </div>
                <div>
                    <span v-text-lbl="'hygl.hyyt.site'">场地：</span>
                    <el-select v-model="selectedSite" :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')" @change="handleSiteChanged">
                        <el-option v-for="item in siteOptions" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </div>
            </div>
        </div>
        <template v-if="selectType === '月'">
            <div class="container-top">
                <!-- 日历筛选区 -->
                <div class="left-calendar">
                    <calendar :get-day-details="setActiveDate" :mark-date.sync="markDate" default-type="month" @getmonth="changeMonth" />
                </div>
                <!-- 右上会议室导览区 -->
                <div class="right-room-view">
                    <!-- <div class="view-header">
                        <div v-text-lbl="'hygl.hyyt.meetingMap'">会议室导览图</div>
                        <div>
                            <span v-text-lbl="'hygl.hyyt.site'">场地：</span>
                            <el-select v-model="selectedSite" :placeholder="$tx('hygl.hyyt.pleaseSelect', '请选择')" @change="handleSiteChanged">
                                <el-option v-for="item in siteOptions" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </div>
                    </div> -->
                    <div v-loading="isLoading" class="view-content">
                        <template v-for="(item, index) in pageData">
                            <div
                                :key="index"
                                class="view-content-item"
                                :class="{
                                    'view-content-item__disabled': isPassDate,
                                    'single-item': pageData.length === 1,
                                    'double-item': pageData.length === 2
                                }"
                            >
                                <div class="view-content-bg" :style="getViewContentTransform(item)">
                                    <img src="../imgs/wave.png" :style="`transform: translate(${viewContentWidth - 5}px, -${345 * Math.random().toFixed(3)}px);width:${viewImgWidth}px;`" />
                                </div>
                                <div class="view-content-item__info">
                                    <span class="item__info-text">{{ item.name }}</span>
                                    <span class="item__info-text">{{ item.deviceProperties ? $tx('hygl.hyyt.Configuration', '设备配置：') + item.deviceProperties : '' }}</span>
                                </div>
                                <el-button class="view-content-item__button" plain :disabled="isPassDate || item.usedTimer / item.usableTimer === 1" @click="toReserve(item)">
                                    {{ getViewButtonText(item) }}
                                </el-button>
                            </div>
                        </template>
                        <template></template>
                    </div>
                </div>
            </div>
            <!-- 底部table区 -->
            <div class="container-bottom">
                <MeetingListTable v-loading="isLoading" :data-list="meetingList" />
            </div>
        </template>
        <template v-else-if="selectType === '周'">
            <meetingReservationWeek ref="meetingReservationWeek" />
        </template>
        <template v-else-if="selectType === '日'">
            <meetingReservationDay ref="meetingReservationWeek" />
        </template>
        <Basicform ref="basicform" :title="formTitle" :append-to-body="true" :win-width="moduleInfo.winWidth" :win-height="moduleInfo.winHeight" :module-code="moduleInfo.moduleCode" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onBasicFormBeforeOpen" :on-basic-form-opened="onBasicFormOpened" :on-basic-form-before-submit="onBasicFormBeforeSubmit" :on-basic-form-submited="onBasicFormSubmited">
            <template #default="slotProps">
                <busi-form ref="busiform" :vo="slotProps.vo" :cur-t-n="{ tnCanEdit: slotProps.canEdit }" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
import MeetingListTable from './components/meetingListTable'
import meetingReservationWeek from './components/meetingReservationWeek'
import meetingReservationDay from './components/meetingReservationDay'

const moment = require('moment')
export default {
    components: {
        MeetingListTable, meetingReservationWeek, meetingReservationDay
    },
    data() {
        return {
            isLoading: false,
            loginUser: this.$store.getters.loginUser,
            selectedSite: '',
            searchFilter: {
                siteId: '',
                startTime: moment(new Date()).format('YYYY-MM-DD'),
                endTime: moment(new Date()).format('YYYY-MM-DD')
            },
            pageData: [],
            selectType: '月',
            meetingList: [],
            markDate: '',
            viewContentWidth: 0,
            viewImgWidth: 140,
            formTitle: '会议室预定',
            moduleInfo: {
                addNewUrl: 'hygl/meeting/addNew',
                delUrl: 'hygl/meeting/delete',
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/hygl/meeting/form.html',
                getByIdUrl: 'hygl/meeting/getById',
                insertUrl: 'hygl/meeting/insert',
                listDataUrl: 'hygl/meeting/listdata',
                moduleCode: 'meeting',
                updateUrl: 'hygl/meeting/update',
                winHeight: 600,
                winWidth: 1000
            },
            meetItem: {},
            weekTimeArr: [],
            dayTime: ''
        }
    },
    computed: {
        isPassDate() {
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            return new Date(this.searchFilter.startTime).getTime() < today.getTime()
        }
    },
    created() {
        this.$options.components['calendar'] = this.$loadComponent('@/wapp/common/components/Calendar/gwapCalendar')
        this.dayTime = moment(new Date()).format('YYYY-MM-DD')
        this.getSiteData()
        this.$bus.emit('showNavSearch', false)
    },
    mounted() {
        window.addEventListener('resize', this.handleWindowResize)
    },
    beforeDestroy() {
        this.$bus.emit('showNavSearch', true)
        window.addEventListener('resize', this.handleWindowResize)
    },
    methods: {
        getViewButtonText(item) {
            if (this.isPassDate) return this.$tx('hygl.hyyt.notAppointment', '不可预约')
            if (item.usedTimer / item.usableTimer === 1) return this.$tx('hygl.hyyt.alreadyBooked', '已约满')
            return this.$tx('hygl.hyyt.appointment', '预 约')
        },
        // 获取会议室占用情况
        getViewContentTransform(item) {
            const usableTimer = item.usableTimer
            const usedTimer = item.usedTimer
            const usedRate = (usedTimer / usableTimer).toFixed(2)
            const totalWidth = this.viewContentWidth + this.viewImgWidth

            console.log('getViewContentTransform => ', item, usedRate)
            if (usedTimer / usableTimer === 1) {
                return ``
            }
            if (usedTimer === 0) {
                return `transform: translate(-${totalWidth}px)`
            }
            return `transform: translate(-${totalWidth - this.viewContentWidth * usedRate}px)`
        },
        // 前往预定
        toReserve(item) {
            if (!item.approve) {
                window.open(`/#/wflow?wfEngineUrl=hygl/roomApply&busiCode=roomApply&wfName=会议室申请&startNodeName=&names=新增&name=${item.name}&site=${this.selectedSite}&weekday=${this.searchFilter.startTime}&siteId=${this.searchFilter.siteId}&id=${item.id}`)
            } else {
                this.meetItem = item
                this.$options.components['BusiForm'] = this.$loadComponent('#/dcontent/vuebusiform/W/hygl.meeting.form.vue?sysCode=' + this.$route.meta.sysCode)
                this.busiformBtns = [
                    {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermission: '',
                        btnType: ''
                    },
                    {
                        id: 'btn_save',
                        btnName: '保 存',
                        btnIcon: 'check',
                        btnClick: 'submitBusiform',
                        btnPermission: 'saveObject',
                        btnType: 'primary'
                    }
                ]
                this.$nextTick(() => {
                    this.$bus.emit('openBusiform', this.moduleInfo, null, 1, (res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            this.getSiteData()
                        }
                    })
                })
            }
        },
        // 浏览器宽度监听
        handleWindowResize() {
            if (document.querySelector('.view-content-item')) {
                this.viewContentWidth = document.querySelector('.view-content-item').offsetWidth
            }
        },
        // 月份变更
        changeMonth(monthDay) {
            this.initMarkDate(moment(monthDay).format('YYYY-MM-DD'))
        },
        // 场地变更
        handleSiteChanged() {
            this.searchFilter.siteId = this.selectedSite
            if (this.selectType === '月') {
                this.initMarkDate(this.searchFilter.startTime)
                this.getMeetingRoomData()
            } else if (this.selectType === '周') {
                // this.getMeetingRoomData()
                this.handleWeekChanged('today')
            } else if (this.selectType === '日') {
                this.handleDayChanged('today')
            }
        },
        // 获取选中时间
        setActiveDate(val, idx) {
            const activeDate = moment(new Date(val.date)).format('YYYY-MM-DD')
            this.searchFilter.startTime = activeDate
            this.searchFilter.endTime = activeDate
            this.getMeetingRoomData()
        },
        // 查寻所有的场地
        getSiteData() {
            this.$http({
                method: 'POST',
                url: 'hygl/site/querydata',
                contentType: 'application/x-www-form-urlencoded',
                data: [
                    {
                        compare: '=',
                        field: 'status',
                        merge: true,
                        value: 1
                    },
                    {
                        compare: '=',
                        field: 'orgCode',
                        merge: true,
                        value: this.loginUser.orgCode
                    }
                ],
                params: { orderBy: 'orderNo asc' }
            }).then((res) => {
                if (res.code === 'success') {
                    const siteList = res.body.listdata
                    this.siteOptions = siteList
                    if (siteList[0]) {
                        this.selectedSite = siteList[0].name
                        this.searchFilter.siteId = siteList[0].id

                        this.getMeetingRoomData()
                        this.initMarkDate(this.searchFilter.startTime)
                    }
                }
            })
        },
        // 年月获取该月第一天跟最后一天
        getStartAndEndDate(date) {
            const dateInfo = new Date(date)
            const month = dateInfo.getMonth() + 1
            const year = dateInfo.getFullYear()

            const firstDate = new Date(year, month - 1, 1) // 月第一天
            const lastDate = new Date(year, month, 0) // 月最后一天
            return [firstDate, lastDate]
        },
        // 初始化有预约会议室的日期数据
        initMarkDate(monthDay) {
            const monthInfo = this.getStartAndEndDate(monthDay)
            const startDate = moment(monthInfo[0]).format('YYYY-MM-DD')
            const endDate = moment(monthInfo[1]).format('YYYY-MM-DD')
            this.getMeetingRoomData(startDate, endDate, (res) => {
                const markDate = []
                res.listdata.forEach((info) => {
                    info.weekdays.forEach((day) => {
                        if (day.meetingList.length) {
                            markDate.push(day.weekday)
                        }
                    })
                })
                this.markDate = markDate.join(',')
            })
        },
        /**
         * 该场地下的会议室信息
         */
        getMeetingRoomData(startDate, endDate, cbFunc = null) {
            this.isLoading = true
            this.$http({
                method: 'GET',
                url: 'hygl/meeting/queryMeetingRoomReserveInfo',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    startDate: startDate || this.searchFilter.startTime,
                    endDate: endDate || this.searchFilter.endTime,
                    siteId: this.searchFilter.siteId
                }
            })
                .then((res) => {
                    if (res.code === 'success') {
                        if (cbFunc) return cbFunc(res.body)
                        const time = moment(new Date()).format('YYYY-MM-DD')

                        // 没有callback时走页面渲染逻辑
                        this.pageData = res.body.listdata.map((item) => {
                            item.usableTimer = new Date(time + ' ' + item.rendtime).getTime() - new Date(time + ' ' + item.rbegintime).getTime()
                            item.usedTimer = item.weekdays[0].meetingList.reduce((prev, day) => {
                                const singleUsedTimer = new Date(day.endTime).getTime() - new Date(day.beginTime).getTime()
                                prev += singleUsedTimer
                                return prev
                            }, 0)
                            if (item.weekdays.length && item.weekdays[0].meetingList.length) {
                                item.weekdays[0].meetingList = item.weekdays[0].meetingList.map((meet) => {
                                    meet.approve = item.approve
                                    return meet
                                })
                            }
                            return item
                        })
                        this.meetingList = res.body.listdata.reduce((prev, curr) => {
                            if (curr.weekdays.length && curr.weekdays[0].meetingList.length) {
                                prev = [...prev, ...curr.weekdays[0].meetingList]
                            }
                            return prev
                        }, [])
                        this.$nextTick(() => this.handleWindowResize())
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        /**
         * 表单打开检查，vo为已加载salary对象，允许打开：defer.resolve(true)，阻止打开：defer.reject(reason)
         */
        onBasicFormBeforeOpen: function ($scope, vo, defer) {
            vo.approve = this.meetItem.approve
            vo.meetName = this.meetItem.name
            vo.meetRoomId = this.meetItem.id
            vo.applayName = this.loginUser.personName
            vo.applyUserid = this.loginUser.personId
            vo.phone = this.loginUser.personMobile
            vo.departmentUser = this.loginUser.staffList[0].orgFullName.split('-')[this.loginUser.staffList[0].orgFullName.split('-').length - 1]
            vo.numPeople = this.meetItem.numPeople
            if (this.meetItem.deviceProperties) {
                const type = this.meetItem.deviceProperties.split(',')
                const typeArray = []
                type.forEach((v) => {
                    typeArray.push({
                        text: v,
                        value: v
                    })
                })
                vo.passenger['devicePropertiesOptions'] = typeArray
            }
            if (this.meetItem.serviceProperties) {
                const type = this.meetItem.serviceProperties.split(',')
                const typeArray = []
                type.forEach((v) => {
                    typeArray.push({
                        text: v,
                        value: v
                    })
                })
                vo.passenger['servicePropertiesOptions'] = typeArray
            }
            vo.weekProperties = this.meetItem.openday
            if (this.meetItem.openday) {
                vo.weeks = this.meetItem.openday
            }
            vo.remark = this.meetItem.remark
            defer.resolve(true)
        },
        handleSelectTypeChanged(val) {
            if (val === '月') {
                this.getSiteData()
            } else if (val === '周') {
                this.handleWeekChanged('today')
            } else if (val === '日') {
                this.handleDayChanged('today')
            }
        },
        // 上一周、下一周
        handleWeekChanged(type) {
            var startDate = ''
            var endDate = ''
            if (type === 'prev') {
                startDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() - 1).startOf('weeks').format('YYYY-MM-DD')
                endDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() - 1).endOf('weeks').format('YYYY-MM-DD')
            } else if (type === 'next') {
                startDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() + 1).startOf('weeks').format('YYYY-MM-DD')
                endDate = moment(this.weekTimeArr[0]).week(moment(this.weekTimeArr[0]).week() + 1).endOf('weeks').format('YYYY-MM-DD')
            } else if (type === 'today') {
                startDate = moment().startOf('weeks').format('YYYY-MM-DD')
                endDate = moment().endOf('weeks').format('YYYY-MM-DD')
            }
            this.weekTimeArr = [startDate, endDate]
            const weekTimeProp = []
            for (let index = 0; index < 7; index++) {
                let obj = {
                    date: moment(startDate).add(index, 'days').format('YYYY-MM-DD'),
                    week: moment(startDate).add(index, 'days').format('dddd').replace('星期', '周'),
                    day: moment(startDate).add(index, 'days').format('DD'),
                    isToday: moment(startDate).add(index, 'days').format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
                }
                weekTimeProp.push(obj)
            }
            this.$nextTick(() => {
                this.$bus.emit('weekTimeChanged', weekTimeProp, this.weekTimeArr)
            })
        },
        // 上一日、下一日
        handleDayChanged(type) {
            this.dayTime = moment(new Date(this.dayTime)).format('YYYY-MM-DD')
            if (type === 'prev') {
                this.dayTime = moment(this.dayTime).subtract(1, 'days').format('YYYY-MM-DD')
            } else if (type === 'next') {
                this.dayTime = moment(this.dayTime).add(1, 'days').format('YYYY-MM-DD')
            } else {
                this.dayTime = moment(new Date()).format('YYYY-MM-DD')
            }
            this.$nextTick(() => {
                this.$bus.emit('dayTimeChanged', this.dayTime)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#MeetingReservation {
    padding: 10px;
    display: flex;
    flex-direction: column;
    .container-top {
        display: flex;
    }
    .container-bottom {
        margin-top: 20px;
    }
    .view-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: var(--portalFontSize14);
        color: #333333;
        padding: 5px 0;
    }
    .left-calendar {
        width: 440px;
        border: 1px solid #edf1fc;
        padding: 3px 0 12px 0;
        border-radius: 2px;
        margin-right: 10px;
        /deep/ .wh_content-day {
            height: 285px;
        }
    }
    .right-room-view {
        display: flex;
        flex-direction: column;
        flex: 1;
        .view-content {
            display: flex;
            flex-wrap: wrap;
            flex: 1;
            margin-bottom: 1px;
            user-select: none;
        }

        .view-content-item {
            position: relative;
            flex: 0 1 33.33%;
            border: 1px solid #edf1fc;
            margin-right: -1px;
            margin-bottom: -1px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            color: #454545;
            overflow: hidden;
        }
        .view-content-item__disabled {
            color: #999999;
        }
        .view-content-bg {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            height: 100%;
            width: 100%;
            background: #add699;
        }

        .view-content-item__info {
            margin: 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            z-index: 1;
            .item__info-text:nth-child(1) {
                font-weight: 700;
                margin-bottom: 10px;
            }
            .item__info-text:nth-child(2) {
                font-weight: 400;
            }
        }

        .single-item {
            flex: 1;
        }
        .double-item {
            flex: 0 1 49.9%;
        }
        .view-content-item__button {
            border-radius: 1px;
            width: 100px;
            z-index: 1;
        }
    }
    .el-icon-arrow-left,.el-icon-arrow-right {
        cursor: pointer;
    }

}
</style>
